import React from 'react';

import './Welcome.scss';

function Welcome({ handleVideoClick, isReturnedAnonimousUser }) {
  return (
    <div className="mn_nagWelcome">
      <h2>Welcome to MileagePlus Shopping<sup>SM</sup></h2>
      { !isReturnedAnonimousUser &&
        <>
          <p>
            Earn up to 1,000 new shopper bonus miles<sup>*</sup>
          </p>

          <ul>
            <li>New shoppers, spend $25 within the first two weeks of sign in to earn 500 bonus miles.</li>
            <li>Card members, spend $25 within the first two weeks of sign in to earn 1,000 bonus miles. </li>
          </ul>
        </>
      }
      <button
        className="mn_watchButtonButton"
        onClick={handleVideoClick}
      >
        Watch a video on how it works
      </button>
    </div>
  );
}

export default Welcome;
